import defaultTopStationsConfig from '../data/top-stations'
import { TopStation } from '../classes/TopStation'
import { StationType } from '../enums/stationType'

import { GeoParentStation, GeoStation } from "@/types/geodata"

export const getStationForId = (
    id: number,
    stationsMap: { [id: string]: GeoStation },
    parentStationsMap: { [id: string]: GeoParentStation },
): TopStation | null => {
    const geoParentStation: GeoParentStation | undefined = parentStationsMap[id]
    const geoStation: GeoStation | undefined = stationsMap[id]
    if (!geoParentStation && !geoStation) return null

    let type: StationType
    if (geoParentStation) type = StationType.PARENT_STATION
    else type = StationType.STATION

    let label: string
    if (geoParentStation) label = geoParentStation.label
    else label = geoStation.label

    const topStation = new TopStation(id, label, type)
    return topStation
}

export const processStationIdArr = (
    idArr: number[],
    stationsMap: { [id: string]: GeoStation } | undefined,
    parentStationsMap: { [id: string]: GeoParentStation } | undefined,
): TopStation[] => {
    const arr: TopStation[] = []
    if (!stationsMap || !parentStationsMap) return arr
    idArr.forEach((id: number) => {
        const station: TopStation | null = getStationForId(id, stationsMap, parentStationsMap)
        if (station) arr.push(station)
        else console.error(`could not locate predefined top station for id: ${id}`)
    })
    return arr
}

export const getDefaultTopStationIds = (locale: string): number[] => {
    if (!locale) throw new Error('locale is mandatory in getTopStations')
    const formattedLocale = locale.replace(/-/g, '_')
    const localizedTopStations = defaultTopStationsConfig[formattedLocale]
    if (!localizedTopStations) throw new Error(`no top stations for locale ${locale}`)
    return localizedTopStations
}